/**
 * Whether the focused element is a field the user types into: an input, a
 * textarea, or a contenteditable surface (the chat document panel's and the
 * Agents file editor's tiptap). Every "take focus for the composer" path asks
 * this one question, so a composer never robs a field the user is already
 * typing in (#11548 r20, #11921, #15552).
 */
export const typingSurfaceHasFocus = (): boolean => {
  const active = document.activeElement;
  return (
    active instanceof HTMLElement &&
    (active.tagName === "INPUT" ||
      active.tagName === "TEXTAREA" ||
      active.isContentEditable)
  );
};
